@if (!isPhone && !isPrint) {
    <div style="right: 0; position: absolute; z-index: 100; margin-right:30px">
        <ng-container *ngTemplateOutlet="customActions"></ng-container>
    </div>
}
@if (isPhone && config.actions && config.actions.length > 0) {
    <div style="margin-right:15px; right: 0">
        <ng-container *ngTemplateOutlet="customActions"></ng-container>
    </div>
}
<ng-template #customActions>
    @if (getActionCount() <= 7) {
        @for (action of config.actions; track action) {
            @if (action.show) {
                @if (action.icon) {
                    <div [matTooltip]="getActionTip(action)" style="display: inline">
                        <button [disabled]="action.disabled || !isEnabled"
                            #menuTrigger="matMenuTrigger"
                            [matMenuTriggerFor]="action.children ? actionMenu : null"
                            (click)="!action.children && takeAction(action)"
                            [attr.data-action-icon]="action.icon"
                            style="margin-bottom: 10px; margin-right: 10px" mat-mini-fab [color]="action.color">
                            <mat-icon>{{action.icon}}</mat-icon>
                        </button>
                    </div>
                } @else {
                    <div [matTooltip]="getActionTip(action)" style="display: inline">
                        <button [disabled]="action.disabled || !isEnabled"
                            #menuTrigger="matMenuTrigger"
                            [matMenuTriggerFor]="action.children ? actionMenu : null"
                            (click)="!action.children && takeAction(action)"
                            [attr.data-action-icon]="action.icon"
                            style="margin-bottom: 19px; margin-right: 10px" mat-raised-button [color]="action.color">
                            <span>{{action.name}}</span>
                        </button>
                    </div>
                }
                <mat-menu #actionMenu="matMenu">
                    <ng-template [ngTemplateOutlet]="customActionMenu" [ngTemplateOutletContext]="{item: action}"></ng-template>
                </mat-menu>
            }
        }
    }
</ng-template>

<ng-template #customActionMenu let-item="item">
    @if (item.children) {
        @for (action of item.children; track $index) {
            @if (action.show) {
                <button (click)="takeAction(action)" [disabled]="action.disabled || !isEnabled"
                    [matTooltip]="getActionTip(action)" [attr.data-action-icon]="action.icon" mat-menu-item>
                    @if (action.icon) {
                        <mat-icon [color]="action.color">{{action.icon}}</mat-icon>
                    }
                    <span>{{action.name}}</span>
                </button>
            }
        }
    }
</ng-template>
